import React, { useContext } from "react";
import { jsx } from "react/jsx-runtime";
// src/contexts/RouterContext.tsx
/**
* Use this context to wrap an entire web-app, ie:
*
* <RouterContext history={reactRouterDOMHistory}>
*
* This context wrapper is used by other hooks in this lib that need access to things such as `history` or `location`.
* When web-apps use "react-router-dom" there can be different versions that exist across apps and this project/package
* needs to be agnostic so it passes these values through in context.
*
*/
var RouterContext = React.createContext({});
var RouterContextProvider = ({ children, history }) => {
	return /* @__PURE__ */ jsx(RouterContext.Provider, {
		value: { history },
		children
	});
};
var useRouterContext = (opts = {}) => {
	const ctx = useContext(RouterContext);
	if (opts.ctxRequired && !ctx) throw new Error("context is required for useRouterContext()");
	return ctx;
};
export { RouterContext, RouterContextProvider, useRouterContext };

//# sourceMappingURL=RouterContext.js.map